home = {
    // Funkcia volana z nativeApp, zobrazenie warning na home obrazovke
    setWarningInfo(warnInfo) {
        try {
            if (profile.HomeWarning && warnInfo && (stored.WarnInfo = JSON.parse(warnInfo))) {
                home.homeWarningToggle(true);
            }
        } catch (e) {
            return false;
        }
    },

    // Funkcia zobrazuje informaciu napriklad o odstavke na home obrazovke
    homeWarningToggle(show) {
        try {
            if (show && (today.getTime() <= new Date(stored.WarnInfo.endDate).getTime())) {
                $("#homeWarning .warning-header").empty().text(stored.WarnInfo.warningHeader);
                $("#homeWarning .warning-text").empty().text(stored.WarnInfo.warningText);
                $("#homeButtons").addClass("warning");
                $("#homeWarning").show();
            } else {
                $("#homeWarning").hide();
                $("#homeButtons").removeClass("warning");
                $("#homeWarning .warning-header, #homeWarning .warning-text").empty();
            }
        } catch (e) {
            $("#homeButtons").removeClass("warning");
            $("#homeWarning").hide();
        }
    },

    // Funkcia na renderovanie home stranky
    homeRender(data) {
        try {
            if (data && !data.ErrorType && data.TopEvents && data.TopEvents.length) {
                $("#topTips #tipNames, #topTips #eventsOfDay, #topTips #eventsOfDayFooter").empty().hide();
                $p("#popularLeaguesTopTips #topTips").render(data, T.TopTips);

                $("#popularLeaguesButton").removeClass('ui-btn-active');
                $("#popularLeagues").hide();
                $("#topTipsButton").removeClass('ui-disabled').addClass('ui-btn-active');

                $("#topTips").show();
                $("#home, #events #noEvents").show();
                $("#empty, #events").hide();
                $("#sportsBook, #sportsBookVG, #sportsBookLG, #eventsIframeWrapper").hide().empty();

                $("#popularLeaguesButton").removeClass('ui-disabled');
                return true;
            } else {
                $("#topTips #tipNames, #topTips #eventsOfDay, #topTips #eventsOfDayFooter").empty();
                $("#home, #events #noEvents").show();
                $("#empty, #events").hide();
                $("#sportsBook, #sportsBookVG, #sportsBookLG, #eventsIframeWrapper").hide().empty();
                // Ak su zapasy dna prazdne, prejde na top ligy
                service.loadPure("popularLeaguesHome");
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            $("#topTips #tipNames, #topTips #eventsOfDay, #topTips #eventsOfDayFooter").empty();
            $("#home, #events #noEvents").show();
            $("#empty, #sportsBook, #events").hide();
            $("#sportsBook, #sportsBookVG, #sportsBookLG, #eventsIframeWrapper").hide().empty();
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return false;
        }
    },

    // Funkcia na renderovanie zapasov dna na home stranke
    popularLeaguesHome(data) {
        try {
            if (data && !data.ErrorType && data.length) {
                var lr = "a", maxLeagues = 10;
                $("#popularLeagues").empty().hide();

                switch (profile.Resolution) {
                    case "1280x1024":
                        maxLeagues = 22;
                        break;
                    case "1680x1050":
                        maxLeagues = 12;
                        break;
                }
                $.each(data, function (i, league) {
                    // pre fullHD rozlisenie zobrazi maximalne 10 poloziek
                    if (i < maxLeagues) {
                        var countryID = "none";
                        if (this.CountryID) countryID = this.CountryID;
                        $("#popularLeagues").append('<div class="popular-league ui-block-' + lr + '"><a data-theme="a" data-role="button" onclick="home.popularLeaguesModule.popularLeagueEvents('
                            + data[i].SportID + ', '
                            + data[i].RegionID + ', '
                            + data[i].LeagueCupID + ')"><span class="ui-icon-sports sport-'
                            + data[i].SportID + ' sport-color-'
                            + data[i].SportID + ' sport-icon-'
                            + data[i].SportID + ' region-'
                            + data[i].RegionID + '"></span><span style="display: none;" class="flat-sport-name">'
                            + data[i].SportName + '</span><div class="league-popular-wrapper"><div class="flat-league sport-border-color-'
                            + data[i].SportID + '"><span class="size22 flag_'
                            + countryID + '"></span><span>'
                            + data[i].RegionName + '</span> - '
                            + data[i].LeagueCupName + '</div><div class="sport-background-colored sport-bgColor-'
                            + data[i].SportID + '"></div></div></a></div>');
                        lr = "b";
                    } else {
                        return false;
                    }
                });
                if (profile.FlatCSS) {
                    $("#popularLeagues a").append("<span class='flat-popular-button'><span class='flat-arrow-right'></span></span>");
                }

                $("#topTipsButton").removeClass("ui-btn-active");
                $("#topTips").hide();
                $("#popularLeaguesButton").removeClass('ui-disabled').addClass("ui-btn-active");

                $("#popularLeagues").trigger("create").show();
                $("#home, #events #noEvents").show();
                $("#empty, #events").hide();
                $("#sportsBook, #sportsBookVG, #sportsBookLG, #eventsIframeWrapper").hide().empty();
                return true;

            } else {
                $("#popularLeagues").empty();
                $("#home, #events #noEvents").show();
                $("#sportsBook, #sportsBookVG, #sportsBookLG, #eventsIframeWrapper").hide().empty();
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            $("#popularLeagues").empty();
            $("#home, #events #noEvents").show();
            $("#empty, #events").hide();
            $("#sportsBook, #sportsBookVG, #sportsBookLG, #eventsIframeWrapper").hide().empty();
        }
    },

    // Nastavi ikonky na home obrazovke
    setHomeIcons() {
        try {
            if (offer) {
                if (offer.dateTD) {
                    if (profile.FlatCSS) {
                        $("#home #homeButtons .dayToday").parent().addClass("icon-calendar");
                        $("#home #homeButtons .dayToday").html((offer.dateTD.substr(8, 2).startsWith('0') ? offer.dateTD.substr(9, 1) : offer.dateTD.substr(8, 2)));
                    } else {
                        $("#home #homeButtons .home-cal-today").attr("src", url.base + "stylesheets/images/icon-cal-" + offer.dateTD.substr(8, 2) + ".png");
                    }
                }
                if (offer.dateTM && !profile.VirtualGames)
                    if (profile.FlatCSS) {
                        $("#home #homeButtons .dayTomorrow").parent().addClass("icon-calendar");
                        $("#home #homeButtons .dayTomorrow").html((offer.dateTM.substr(8, 2).startsWith('0') ? offer.dateTM.substr(9, 1) : offer.dateTM.substr(8, 2)));
                    } else {
                        $("#home #homeButtons .home-cal-tomorrow").attr("src", url.base + "stylesheets/images/icon-cal-" + offer.dateTM.substr(8, 2) + ".png");
                    }
                stored.dateTD = offer.dateTD;
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na premapovanie homeButton na setPage
    homeButton(button) {
        try {
            // Animacia kliku tlacitka
            $("#home").addClass("lock-btn").find("#homeButtons .ui-block-" + button).addClass("ui-disabled");
            setTimeout(function () {
                if (!offer.live && (button == "a" || (profile.VirtualGames && button == "d"))) {
                    $("#home").removeAttr("class");
                } else {
                    $("#home").removeAttr("class").find("#homeButtons .ui-block-" + button).removeClass("ui-disabled");
                }
                if (profile.QuickBetsAllowed && profile.QuickBets.HomePage) {
                    $("#home").addClass("has-quickbet");
                }
            }, 500);

            switch (button) {
                case "a":
                    main.setPage(3);
                    break
                case "b":
                    if ((profile.Club || profile.Bonuses) && profile.ClubHomeButton) {
                        // Ak nie je nastavena ClubPageAutoOpen a je beziaca sutaz, ktora ma nastavene ID rebricka aj ID sekcie tak nastavi ClubPageAutoOpen na ID sekcie danej sutaze
                        if (!profile.ClubPageAutoOpen && profile.ClubCompetition && profile.ClubCompetitionIDs && profile.ClubPageCompetition) profile.ClubPageAutoOpen = profile.ClubPageCompetition;
                        // Otvorenie DOXXbet klubu
                        if (profile.Bonuses && profile.BonusList && profile.BonusList.length) {
                            // ak klikam na zmenenu dlazdicu, napr nejaky bonus, nacitam, poradie pre submenu, lebo moze byt resetovane
                            stored.bonusIndexToOpen = $("#homeButtons .ui-block-b .home-button").data("bonus-index") || profile.BonusOpenDefault || 0;
                            main.openPage('bonuses', stored.bonusIndexToOpen);
                        } else {
                            main.openPage('club');
                            // Automaticke otvorenie zvolenej sekcie DOXXbet klubu
                            setTimeout(function () {
                                if (profile.ClubPageAutoOpen) more.menu.clubPage(profile.ClubPageAutoOpen);
                            }, 500);
                        }
                    } else {
                        main.setPage(4);
                    }
                    break
                case "c":
                    main.setPage(5);
                    break
                case "d":
                    if (profile.LotteryAllowed) {
                        main.setPage(7);
                    } else if (profile.VirtualGames) {
                        main.setPage(8);
                    } else {
                        main.setPage(6);
                    }
                    break
                default:
                    main.setPage(1);
                    break
            }
            // Doslo k pouzitu homeButton - vyuzite vo funkcii ticket.ticketOddModule.setLogOdd()
            offer.homeButtonUsed = true;

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia ktoru vola nativeApp, sluzi na nastavenie home dlazdice
    setTile(tileData) {
        try {
            if (profile.Bonuses && tileData && (tileData = JSON.parse(tileData))) {
                if (!tileData.isEmpty && tileData.imageUrl) {
                    profile.TileInfo.imageUrl = tileData.imageUrl;
                }
                more.menu.getBonusList(tileData);
                return true;
            }
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia, ktora nastavi 4. tlacitko na home obrazovke
    set4thHomeButton() {
        try {
            if (profile.LotteryAllowed) {
                // Nastavenie tlacitka - Ball games na homeScreene (tlacidlo d)
                $("#homeButtons .ui-block-d").addClass("home-lottery-games")
                    .html('<div class="home-button"><div>'
                        + texts.FooterLabelLotteryGames + '</div></div>');
            } else if (profile.VirtualGames) {
                // Nastavenie tlacitka - Virtual games na homeScreene (tlacidlo d)
                $("#homeButtons .ui-block-d").addClass("home-virtual-games")
                    .attr('data-track', 'vg')
                    .html('<img class="home-icon" src="stylesheets/images/icon-virtualGames.png"><div class="home-button"><div>'
                        + texts.FooterLabelVirtualGames + '</div><span class="home-new"></span></div>');

                // Zobrazenie ze sa jedna o novinku
                if (profile.NewVirtualGameIDs && profile.NewVirtualGameIDs.length) $("#homeButtons .ui-block-d .home-new").addClass("new-game-" + offer.lang);

            } else {
                // Nastavenie povodneho tlactika na homeScreene
                $("#homeButtons .ui-block-d").removeClass("home-virtual-games")
                    .attr('data-track', '')
                    .html('<img class="home-icon home-cal-tomorrow"><div class="home-button icon-calendar"><div>'
                        + texts.FooterLabelOtherDates + '</div><span class="dayTomorrow" style="display: none"></span></div>');
                home.setHomeIcons();
            }

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Prepinanie medzi zapasmi dna a top ligami na home
    switchPLTT(tabToSwitch) {
        try {
            switch (tabToSwitch) {
                case 'topTips':
                    // Zobrazi Zapasy dna (default na home obrazovke)
                    service.loadPure("home");
                    break;
                case 'popularLeagues':
                    // Zobrazi Popularne ligy
                    service.loadPure("popularLeaguesHome");
                    break;
                default:
                    break;
            }
            return true;
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
